import { get } from "svelte/store";
import { roleStore } from "../stores/roleStore";
import { replace } from "svelte-spa-router";
import { getLang } from "./window";
export function navigateWithParams(path = "/") {
    const lang = getLang();
    const role = get(roleStore);
    const params = new URLSearchParams({ lang });
    if (role) {
        params.append("role", role);
    }
    replace(`${path}?${params.toString()}`);
}
